import CancelIcon from '@mui/icons-material/Cancel'
import { Button, Divider, Stack, Typography } from '@mui/material'
import {
  DataGridProProps,
  GridPagination,
  gridRowSelectionStateSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'

export type ServerPaginationFooterProps = DataGridProProps & {
  hideFooterPagination: boolean
  disableRowDeselect: boolean
}

export const ServerPaginationFooter = ({
  hideFooterPagination,
  disableRowDeselect,
}: ServerPaginationFooterProps) => {
  const { t } = useTranslation('@cibo/ui/ServerPaginationFooter')
  const grid = useGridApiContext()
  const rowSelectionModel = useGridSelector(grid, gridRowSelectionStateSelector)

  return (
    <>
      <Divider />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" p={1} alignItems="center" spacing={2}>
          {rowSelectionModel.ids.size > 0 ? (
            !disableRowDeselect ? (
              <>
                <Button
                  onClick={() =>
                    grid.current.setRowSelectionModel(
                      { type: 'include', ids: new Set() },
                      'multipleRowsSelection'
                    )
                  }
                  data-testid="clear-selection"
                  startIcon={<CancelIcon />}
                >
                  {t('clearSelection', { count: rowSelectionModel.ids?.size })}
                </Button>
              </>
            ) : (
              <Typography>{t('selectionCount', { count: rowSelectionModel.ids.size })}</Typography>
            )
          ) : null}
        </Stack>

        {!hideFooterPagination && <GridPagination {...({} as any)} />}
      </Stack>
    </>
  )
}
